var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogoCrossed(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 11.5V7H9.5M4.15804 10.8452C4.05477 11.2321 4 11.6365 4 12.0526L4 19L5.13909 17.9536C6.17054 17.006 7.56948 16.4737 9.02817 16.4737H9.5C9.8415 16.4737 10.1757 16.4531 10.5 16.4125",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20 7H20.75C20.75 6.58579 20.4142 6.25 20 6.25V7ZM16.4645 8.31802L16.9662 8.87549H16.9662L16.4645 8.31802ZM20 11.5L20.75 11.5V11.5H20ZM19.25 16C19.25 16.4142 19.5858 16.75 20 16.75C20.4142 16.75 20.75 16.4142 20.75 16H19.25ZM20 6.25C18.499 6.25 17.0457 6.78591 15.9627 7.76055L16.9662 8.87549C17.7586 8.1623 18.8488 7.75 20 7.75V6.25ZM20.75 11.5V7H19.25V11.5H20.75ZM20.75 16L20.75 11.5L19.25 11.5L19.25 16H20.75ZM15.9627 7.76055C14.8772 8.73753 14.25 10.0806 14.25 11.5H15.75C15.75 10.5325 16.1764 9.58634 16.9662 8.87549L15.9627 7.76055Z",
    fill: "currentColor",
    stroke: "currentColor",
    strokeWidth: 0,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2 4L18 20",
    stroke: "currentColor",
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoCrossed);
export default __webpack_public_path__ + "static/media/logo-crossed.79891f6f884d517d78fbb545cb8ef17a.svg";
export { ForwardRef as ReactComponent };